module.exports = __webpack_public_path__ + "static/img/new_bg.a70f4b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/new_bg.png
// module id = lBcs
// module chunks = 1